// @ts-check
// "Importar" da barra de view, ao lado de "Exportar": abre o assistente de importação do objeto.
import { html } from 'htm/preact';
import { useState } from 'preact/hooks';
import { Icon } from '../../ui/icon.js';
import { t } from '../../i18n/index.js';
import { SpreadsheetImportDialog } from './spreadsheet-import-dialog.js';
import { useListCommandRequest } from '../command-menu/command-state.js';

// membros da equipe vêm de convites; o motor também recusa importar neles
const NOT_IMPORTABLE_OBJECTS = new Set(['workspaceMember']);

/**
 * @param {{ objectMetadata: import('../../lib/field-metadata.js').ObjectMetadata, viewId?: string }} props
 *   viewId: o menu de comandos e o botão fixado do cabeçalho pedem para abrir o assistente desta view
 */
export function ImportRecordsButton({ objectMetadata, viewId = '' }) {
  const [isOpen, setIsOpen] = useState(false);
  useListCommandRequest('import', viewId, () => setIsOpen(true));
  if (objectMetadata.isSystem || NOT_IMPORTABLE_OBJECTS.has(objectMetadata.nameSingular)) return null;
  return html`
    <button type="button" class="header-dropdown-button" title=${t('spreadsheetImport.tooltip')} onClick=${() => setIsOpen(true)}>
      <${Icon} name="IconUpload" size=${14} />
      <span class="export-records-label">${t('spreadsheetImport.button')}</span>
    </button>
    ${isOpen ? html`<${SpreadsheetImportDialog} objectMetadata=${objectMetadata} onClose=${() => setIsOpen(false)} />` : null}
  `;
}
